import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';

// this is only loader and redirector when loaded directly from browser,
// loading should not happen in the app, because walls array should be filled
// by the walls20 component which triggers the rendering of this component

const WallsAsPage = ({
  walls,
  fetchWalls,
  page,
  activeFilters
}) => {
  const [to, setTo] = useState(null);

  useEffect(() => {
    if (walls.length) {
      const index = 0;
      setTo(`${ walls[index].href }?${ queryString.stringify(activeFilters) }`);
    } else {
      fetchWalls({ page, ...activeFilters });
    }
  }, [walls.length]);

  if (to) {
    return <Redirect to={ to } />;
  }

  return <div />;
};

WallsAsPage.propTypes = {
  fetchWalls: PropTypes.func.isRequired,
  walls: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  activeFilters: PropTypes.object.isRequired
};

export default WallsAsPage;
